module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ja":"Japan","other":"Other"},"ja":{"ja":"日本","other":"その他"}}')
  delete Component.options._Ctor
}
